import { render, staticRenderFns } from "./PodrAdd.vue?vue&type=template&id=b23986d8&scoped=true&"
import script from "./PodrAdd.vue?vue&type=script&lang=js&"
export * from "./PodrAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23986d8",
  null
  
)

export default component.exports